import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Subject, distinctUntilChanged, filter, map, switchMap, takeUntil, tap } from 'rxjs';

import { AuthenticationService } from './shared/services/authentication.service';
import { DeviceService } from './shared/services/device.service';
import { MatIconRegistry } from '@angular/material/icon';
import { ActivatedRoute, NavigationEnd, Route, Router } from '@angular/router';
import { VersionService } from './shared/services/version.service';
import { environment } from '../environments/environment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {

  public readonly appName = environment.appName;
  public readonly brand = environment.brandKey;
  private readonly destroyed$ = new Subject<boolean>();

  constructor(
    private readonly iconRegistry: MatIconRegistry,
    private readonly sanitizer: DomSanitizer,
    private readonly device: DeviceService,
    private readonly auth: AuthenticationService,
    private readonly versionService: VersionService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    title: Title,
  ) {
    this.handleIcons();
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      tap(() => {
        let path = this.route.root;
        let _title = path.snapshot.data?.title;
        while(path.firstChild) {
          path = path.firstChild;
          _title = path.snapshot.data?.title || _title;
        }
        title.setTitle(_title ? `${_title} | ${this.appName}` : this.appName);
       }),
      takeUntilDestroyed(),
    ).subscribe();
  }

  async ngOnInit(): Promise<void> {
    this.versionService.binaryOutOfDate$.pipe(
      takeUntil(this.destroyed$),
      distinctUntilChanged(),
      filter(value => value),
      switchMap(() => this.router.navigate(['/out-of-support'])),
    ).subscribe();


    await this.auth.init();
    console.log('🔍', 'Initializing...');
    await this.device.registerDevice();
    console.log('🔍', 'Initialized!');
  }

  /**
   * Adds custom icons to be used in mat-icon.
   * Usage: <mat-icon svgIcon="iconName"></mat-icon>
   */
  handleIcons() {
    //  keep in alphabetical order to make it easier to see what is there
    const icons = [
      'comments',
    ];
    icons.forEach(icon => {
      const path = `assets/icons/${icon}.svg`;
      const sanitizedPath = this.sanitizer.bypassSecurityTrustResourceUrl(path);
      this.iconRegistry.addSvgIcon(icon, sanitizedPath);
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
